export default __webpack_public_path__ + "static/media/Calendar.5f72e366.svg";